import { render, staticRenderFns } from "./invisitList.vue?vue&type=template&id=4b52d40f&scoped=true&name=invisitList&"
import script from "./invisitList.vue?vue&type=script&lang=js&"
export * from "./invisitList.vue?vue&type=script&lang=js&"
import style0 from "./invisitList.vue?vue&type=style&index=0&id=4b52d40f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52d40f",
  null
  
)

export default component.exports